import * as React from 'react';
import classes from './IPhone.module.scss';
import { WithChildren } from '../../../../models/children-props';
import { Loader } from '../../../../components/containers/Loader';
import { useContext } from 'react';
import { InstagramGridContext } from '../../../../providers/InstagramGridProvider';

export type IPhoneViewProps = WithChildren<{
  // ...
}>;

export const IPhoneView = ({ children }: IPhoneViewProps): JSX.Element => {
  const { loadingPosts } = useContext(InstagramGridContext);

  return (
    <div className={classes.IPhone}>
      <div className={classes.IPhoneInner}>
        <div className={classes.IPhoneHeader}>
          <div className={classes.IPhoneHeaderInner}>
            <div className={classes.IPhoneHeaderItem}></div>
            <div className={classes.IPhoneHeaderCircle}>
              <div className={classes.IPhoneHeaderCircleInner}>
                <div className={classes.IPhoneHeaderCircleItem}></div>
                <div className={classes.IPhoneHeaderCircleItem}></div>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.IPhoneMain}>
          {loadingPosts ? <Loader size={'medium'} variation={'dark'} type={'inline'} /> : <>{children}</>}
        </div>
      </div>
    </div>
  );
};
